export const getParamFromUrl = (url: string, param: string) => {
  const urlObject = new URL(url);
  const searchParams = new URLSearchParams(urlObject.search);
  return searchParams.get(param);
};

export const getTokenFromUrl = () => {
  const token = getParamFromUrl(window.location.href, 'token');
  const storageToken = localStorage.getItem('START_PARAM_TOKEN');

  let resultToken: string | null;

  if (token) {
    resultToken = token;
    if (token !== storageToken) {
      localStorage.setItem('START_PARAM_TOKEN', token);
    }
  } else {
    resultToken = localStorage.getItem('START_PARAM_TOKEN');
  }

  return resultToken ? atob(resultToken) : '';
};

export const getStartParamFromUrl = () => {
  const startParam = getParamFromUrl(window.location.href, 'start_param');
  const storageStartParam = localStorage.getItem('START_PARAM');

  let resultStartParam: string | null;

  if (startParam) {
    resultStartParam = startParam;
    if (startParam !== storageStartParam) {
      localStorage.setItem('START_PARAM', startParam);
    }
  } else {
    resultStartParam = localStorage.getItem('START_PARAM');
  }

  return resultStartParam || '';
};
